import React, { useState } from 'react';
import AircraftFleetCard from './AircraftFleetCard';
import AircraftDocumentsPanel from './AircraftDocumentsPanel';

export default function AircraftFleetPanel({
  aircraftList,
  aircraftDefects,
  appSettings,
  regInput,
  success,
  error,
  aircraftStatusMessage,
  aircraftStatusError,
  expandedStatusAircraftId,
  aircraftStatusActionId,
  expandedWbAircraftId,
  wbDraftMap,
  aircraftDetailsDraftMap,
  onRegInputChange,
  onAddAircraft,
  onUpdateAircraftMethod,
  onAircraftImageUpload,
  onToggleWb,
  onToggleReview,
  onRemoveAircraft,
  onAircraftStatusChange,
  onRectifyDefect,
  onUpdateWbDraft,
  onUpdateAircraftDetailsDraft,
  onSaveAircraftDetails,
  onSaveWbConstants,
}) {
  const [fleetOpen, setFleetOpen] = useState(false);
  const aircraftCount = Array.isArray(aircraftList)
    ? aircraftList.length
    : 0;

  function getAircraftOpenDefects(aircraftId) {
    return aircraftDefects.filter(
      (defect) =>
        String(defect.aircraft_id) === String(aircraftId) &&
        String(defect.status || '').toLowerCase() !==
          'rectified'
    );
  }

  function updateLoadingStation(
    aircraftId,
    loadingStations,
    stationIndex,
    field,
    value
  ) {
    const nextStations = loadingStations.map(
      (station, index) =>
        index === stationIndex
          ? {
              ...station,
              [field]: value,
            }
          : station
    );

    onUpdateWbDraft(
      aircraftId,
      'loadingStations',
      nextStations
    );
  }

  function addLoadingStation(
  aircraftId,
  loadingStations
) {
  const stationName = window.prompt(
    'Enter the loading station name:'
  );

  if (stationName === null) {
    return;
  }

  const trimmedName = stationName.trim();

  if (!trimmedName) {
    window.alert(
      'Please enter a loading station name.'
    );
    return;
  }

  const nameAlreadyExists = loadingStations.some(
    (station) =>
      String(station.name || '')
        .trim()
        .toLowerCase() ===
      trimmedName.toLowerCase()
  );

  if (nameAlreadyExists) {
    window.alert(
      'A loading station with this name already exists.'
    );
    return;
  }

  const nextStations = [
    ...loadingStations,
    {
      id: `station-${Date.now()}`,
      name: trimmedName,
      type: 'other',
      arm: '',
      maxWeight: '',
    },
  ];

  onUpdateWbDraft(
    aircraftId,
    'loadingStations',
    nextStations
  );
}

  function removeLoadingStation(
    aircraftId,
    loadingStations,
    stationIndex
  ) {
    const nextStations = loadingStations.filter(
      (_station, index) => index !== stationIndex
    );

    onUpdateWbDraft(
      aircraftId,
      'loadingStations',
      nextStations
    );
  }

  return (
    <section style={{ marginBottom: '2.5rem' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 10,
          marginBottom: '1rem',
        }}
      >
        <h3
          style={{
            color: '#b6eaff',
            fontSize: '1.3rem',
            margin: 0,
          }}
        >
          Aircraft Fleet ({aircraftCount})
        </h3>

        <button
          type="button"
          onClick={() => setFleetOpen((previous) => !previous)}
          style={{
            background: '#24446f',
            color: '#d7ebff',
            border: '1px solid #3a5f92',
            borderRadius: 8,
            padding: '0.45rem 0.8rem',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {fleetOpen ? 'Collapse' : 'Open'}
        </button>
      </div>

      {!fleetOpen ? null : (
        <>

      <form
        onSubmit={onAddAircraft}
        style={{
          display: 'flex',
          gap: '1rem',
          marginBottom: '1.5rem',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <input
          type="text"
          placeholder="Registration"
          value={regInput}
          onChange={onRegInputChange}
          style={{
            flex: 1,
            minWidth: 180,
            padding: '0.6rem 1rem',
            borderRadius: 6,
            border: '1px solid #1ecfff',
            background: '#23243a',
            color: 'white',
            fontSize: '1rem',
            outline: 'none',
            textTransform: 'uppercase',
          }}
          autoCorrect="off"
          autoComplete="off"
          spellCheck={false}
        />

        <button
          type="submit"
          style={{
            background: '#1ecfff',
            color: '#090a12',
            border: 'none',
            borderRadius: 8,
            padding: '0.7rem 1.2rem',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          ADD AIRCRAFT
        </button>
      </form>

      

      {error && (
        <div
          style={{
            color: '#ff8d8d',
            marginBottom: '1rem',
          }}
        >
          {error}
        </div>
      )}

      {aircraftStatusMessage && (
        <div
          style={{
            color: '#1ecfff',
            marginBottom: 10,
          }}
        >
          {aircraftStatusMessage}
        </div>
      )}

      {aircraftStatusError && (
        <div
          style={{
            color: '#ff8d8d',
            marginBottom: 10,
          }}
        >
          {aircraftStatusError}
        </div>
      )}

      {aircraftList.length === 0 ? (
        <div
          style={{
            background: '#23243a',
            border: '1px solid #2f466d',
            borderRadius: 10,
            padding: '1rem',
            color: '#8db7e6',
          }}
        >
          No aircraft added yet.
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gap: 10,
          }}
        >
          {aircraftList.map((aircraft) => {
            const statusMeta = getAircraftStatusMeta(
              aircraft.status
            );

            const openDefects = getAircraftOpenDefects(
              aircraft.id
            );

            const isExpanded =
              expandedStatusAircraftId ===
              String(aircraft.id);

            const isBusy =
              aircraftStatusActionId ===
              String(aircraft.id);

            const isWbExpanded =
              expandedWbAircraftId ===
              String(aircraft.id);

            const wbDraft =
              wbDraftMap[String(aircraft.id)] || {};

            const aircraftDetailsDraft =
              aircraftDetailsDraftMap?.[String(aircraft.id)] || {};

            const loadingStations = Array.isArray(
              wbDraft.loadingStations
            )
              ? wbDraft.loadingStations
              : [];

            return (
              <div key={aircraft.id}>
                <AircraftFleetCard
                  aircraft={aircraft}
                  statusMeta={statusMeta}
                  openDefects={openDefects}
                  isExpanded={isExpanded}
                  isBusy={isBusy}
                  isWbExpanded={isWbExpanded}
                  appSettings={appSettings}
                  onRecordingMethodChange={
                    onUpdateAircraftMethod
                  }
                  onPhotoUpload={onAircraftImageUpload}
                  onToggleWb={onToggleWb}
                  onToggleReview={() =>
                    onToggleReview(
                      isExpanded
                        ? ''
                        : String(aircraft.id)
                    )
                  }
                  onRemove={() =>
                    onRemoveAircraft(
                      aircraft.id,
                      aircraft.registration
                    )
                  }
                />

                {isExpanded && (
                  <div
                    style={{
                      marginTop: 12,
                      paddingTop: 12,
                      borderTop: '1px solid #2f466d',
                    }}
                  >
                    <div
                      style={{
                        marginBottom: 14,
                        padding: '0.75rem',
                        border: '1px solid #35507f',
                        borderRadius: 8,
                        background: '#12182a',
                      }}
                    >
                      <div
                        style={{
                          marginBottom: '0.75rem',
                        }}
                      >
                        <label
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                          }}
                        >
                          <span
                            style={{
                              color: '#b6eaff',
                              fontSize: '0.82rem',
                              fontWeight: 500,
                            }}
                          >
                            Engine category
                          </span>
                          <select
                            value={
                              aircraftDetailsDraft.engine_count ??
                              aircraft.engine_count ??
                              ''
                            }
                            onChange={(event) =>
                              onUpdateAircraftDetailsDraft(
                                aircraft.id,
                                'engine_count',
                                event.target.value
                              )
                            }
                            style={{
                              width: '220px',
                              boxSizing: 'border-box',
                              borderRadius: 8,
                              padding:
                                '0.45rem 0.7rem',
                              border:
                                '1px solid #35507f',
                              fontSize: '0.82rem',
                              background: '#23243a',
                              color: '#8db7e6',
                              outline: 'none',
                            }}
                          >
                            <option value="">
                              Please select
                            </option>
                            <option value="1">
                              Single-engine
                            </option>
                            <option value="2">
                              Multi-engine
                            </option>
                          </select>
                        </label>
                        <div
                          style={{
                            color: '#8db7e6',
                            fontSize: '0.75rem',
                            marginTop: '0.5rem',
                          }}
                        >
                          Automatically identified from
                          the aircraft type where
                          available. You can correct it
                          here.
                        </div>
                      </div>

                      <div
                        style={{
                          color: '#8db7e6',
                          fontSize: '0.82rem',
                          marginBottom: '0.75rem',
                        }}
                      >
                        Optional. Used for live flight
                        tracking and ADS-B map links.
                      </div>

                      <button
                        type="button"
                        onClick={() =>
                          onSaveAircraftDetails(aircraft)
                        }
                        style={{
                          marginTop: 8,
                          background: '#1ecfff',
                          color: '#090a12',
                          border: 'none',
                          borderRadius: 8,
                          padding: '0.35rem 0.8rem',
                          fontWeight: 700,
                          cursor: 'pointer',
                        }}
                      >
                        SAVE AIRCRAFT DETAILS
                      </button>

                      {success && (
                        <div
                          style={{
                            marginTop: 8,
                            fontSize: '0.82rem',
                            color: '#8ff4b6',
                          }}
                        >
                          {success}
                        </div>
                      )}

                      {error && (
                        <div
                          style={{
                            marginTop: 8,
                            fontSize: '0.82rem',
                            color: '#ff8d8d',
                          }}
                        >
                          {error}
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        gap: 8,
                        flexWrap: 'wrap',
                        marginBottom: 12,
                      }}
                    >
                      <button
                        type="button"
                        onClick={() =>
                          onAircraftStatusChange(
                            aircraft.id,
                            'serviceable'
                          )
                        }
                        disabled={isBusy}
                        style={{
                          background: '#8ff4b6',
                          color: '#062411',
                          border: 'none',
                          borderRadius: 8,
                          padding: '0.4rem 0.7rem',
                          fontWeight: 700,
                          cursor: isBusy
                            ? 'wait'
                            : 'pointer',
                          opacity: isBusy ? 0.7 : 1,
                        }}
                      >
                        SERVICEABLE
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          onAircraftStatusChange(
                            aircraft.id,
                            'deferred'
                          )
                        }
                        disabled={isBusy}
                        style={{
                          background: '#ffd27a',
                          color: '#2e1a00',
                          border: 'none',
                          borderRadius: 8,
                          padding: '0.4rem 0.7rem',
                          fontWeight: 700,
                          cursor: isBusy
                            ? 'wait'
                            : 'pointer',
                          opacity: isBusy ? 0.7 : 1,
                        }}
                      >
                        DEFERRED
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          onAircraftStatusChange(
                            aircraft.id,
                            'aog'
                          )
                        }
                        disabled={isBusy}
                        style={{
                          background: '#ff4d4d',
                          color: '#2b0505',
                          border: 'none',
                          borderRadius: 8,
                          padding: '0.4rem 0.7rem',
                          fontWeight: 700,
                          cursor: isBusy
                            ? 'wait'
                            : 'pointer',
                          opacity: isBusy ? 0.7 : 1,
                        }}
                      >
                        AOG
                      </button>
                    </div>

                    {openDefects.length === 0 ? (
                      <div
                        style={{
                          color: '#8db7e6',
                          marginBottom: 12,
                        }}
                      >
                        No open defects recorded for this
                        aircraft.
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'grid',
                          gap: 8,
                          marginBottom: 12,
                        }}
                      >
                        {openDefects.map((defect) => (
                          <div
                            key={defect.id}
                            style={{
                              background: '#12182a',
                              border:
                                '1px solid #35507f',
                              borderRadius: 8,
                              padding: '0.75rem',
                            }}
                          >
                            <div
                              style={{
                                color: '#ffd27a',
                                fontWeight: 800,
                                marginBottom: 4,
                              }}
                            >
                              {String(
                                defect.severity ||
                                  'defect'
                              ).toUpperCase()}{' '}
                              DEFECT
                            </div>

                            <div
                              style={{
                                color: '#d7ebff',
                                whiteSpace: 'pre-wrap',
                                marginBottom: 6,
                              }}
                            >
                              {defect.details ||
                                'No details entered.'}
                            </div>

                            <button
                              type="button"
                              onClick={() =>
                                onRectifyDefect(defect)
                              }
                              style={{
                                marginTop: 8,
                                background: '#8ff4b6',
                                color: '#062411',
                                border: 'none',
                                borderRadius: 8,
                                padding:
                                  '0.45rem 0.75rem',
                                fontWeight: 700,
                                cursor: 'pointer',
                              }}
                            >
                              RECTIFY DEFECT
                            </button>

                            <div
                              style={{
                                color: '#8db7e6',
                                fontSize: '0.85rem',
                                marginTop: 6,
                              }}
                            >
                              Booking:{' '}
                              {defect.booking_id || '-'}{' '}
                              • Status:{' '}
                              {String(
                                defect.status || 'open'
                              ).toUpperCase()}{' '}
                              • Reported:{' '}
                              {defect.reported_at
                                ? new Date(
                                    defect.reported_at
                                  ).toLocaleString()
                                : '-'}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    <AircraftDocumentsPanel
                      aircraft={aircraft}
                    />
                  </div>
                )}

                {isWbExpanded && (
                  <div
                    style={{
                      marginTop: 8,
                      padding: '0.75rem',
                      border: '1px solid #35507f',
                      borderRadius: 8,
                      background: '#12182a',
                    }}
                  >
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns:
                          'repeat(auto-fit, minmax(160px, 1fr))',
                        gap: 8,
                      }}
                    >
                      <label style={wbLabelStyle}>
                        SEATING LAYOUT
                        <select
                          value={wbDraft.seatLayout || '4'}
                          onChange={(event) =>
                            onUpdateWbDraft(
                              aircraft.id,
                              'seatLayout',
                              event.target.value
                            )
                          }
                          style={wbInputStyle}
                        >
                          <option value="2">
                            2 seats
                          </option>

                          <option value="4">
                            4 seats
                          </option>

                          <option value="other">
                            Other
                          </option>
                        </select>
                      </label>

                      <label style={wbLabelStyle}>
                        EMPTY WEIGHT
                        <input
                          type="number"
                          step="0.1"
                          value={
                            wbDraft.emptyWeight || ''
                          }
                          onChange={(event) =>
                            onUpdateWbDraft(
                              aircraft.id,
                              'emptyWeight',
                              event.target.value
                            )
                          }
                          style={wbInputStyle}
                        />
                      </label>

                      <label style={wbLabelStyle}>
  EMPTY CG / ARM
  <input
    type="number"
    step="0.1"
    value={
      wbDraft.emptyMoment || ''
    }
    onChange={(event) =>
      onUpdateWbDraft(
        aircraft.id,
        'emptyMoment',
        event.target.value
      )
    }
    style={wbInputStyle}
  />

  <div
    style={{
      marginTop: 4,
      fontSize: '0.72rem',
      color: '#8db7e6',
    }}
  >
    Wingit calculates the empty moment automatically.
  </div>
</label>

                      <label style={wbLabelStyle}>
                        MAX TAKEOFF WEIGHT
                        <input
                          type="number"
                          step="0.1"
                          value={
                            wbDraft.maxTakeoffWeight ||
                            ''
                          }
                          onChange={(event) =>
                            onUpdateWbDraft(
                              aircraft.id,
                              'maxTakeoffWeight',
                              event.target.value
                            )
                          }
                          style={wbInputStyle}
                        />
                      </label>

                      <label style={wbLabelStyle}>
                        MIN CG
                        <input
                          type="number"
                          step="0.1"
                          value={wbDraft.minCg || ''}
                          onChange={(event) =>
                            onUpdateWbDraft(
                              aircraft.id,
                              'minCg',
                              event.target.value
                            )
                          }
                          style={wbInputStyle}
                        />
                      </label>

                      <label style={wbLabelStyle}>
                        MAX CG
                        <input
                          type="number"
                          step="0.1"
                          value={wbDraft.maxCg || ''}
                          onChange={(event) =>
                            onUpdateWbDraft(
                              aircraft.id,
                              'maxCg',
                              event.target.value
                            )
                          }
                          style={wbInputStyle}
                        />
                      </label>

                      <div
                        style={{
                          gridColumn: '1 / -1',
                          border:
                            '1px solid #35507f',
                          borderRadius: 8,
                          padding: '0.75rem',
                          background: '#18233a',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent:
                              'space-between',
                            alignItems: 'center',
                            gap: 10,
                            marginBottom: 10,
                            flexWrap: 'wrap',
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 700,
                              color: '#b6eaff',
                            }}
                          >
                            Loading stations
                          </div>

                          <button
                            type="button"
                            onClick={() =>
                              addLoadingStation(
                                aircraft.id,
                                loadingStations
                              )
                            }
                            style={smallBlueButtonStyle}
                          >
                            ADD STATION
                          </button>
                        </div>

                        {loadingStations.length === 0 ? (
                          <div
                            style={{
                              color: '#8db7e6',
                            }}
                          >
                            No loading stations added.
                          </div>
                        ) : (
                          <div
                            style={{
                              display: 'grid',
                              gap: 10,
                            }}
                          >
                            {loadingStations.map(
                              (station, index) => (
                                <div
                                  key={
                                    station.id ||
                                    `station-${index}`
                                  }
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns:
                                      'minmax(150px, 2fr) minmax(120px, 1fr) minmax(100px, 1fr) minmax(120px, 1fr) auto',
                                    gap: 8,
                                    alignItems: 'end',
                                    padding: '0.75rem',
                                    border:
                                      '1px solid #2f466d',
                                    borderRadius: 8,
                                    background: '#12182a',
                                  }}
                                >
                                  <label
                                    style={wbLabelStyle}
                                  >
                                    NAME
                                    <input
                                      type="text"
                                      value={
                                        station.name || ''
                                      }
                                      onChange={(event) =>
                                        updateLoadingStation(
                                          aircraft.id,
                                          loadingStations,
                                          index,
                                          'name',
                                          event.target.value
                                        )
                                      }
                                      style={wbInputStyle}
                                    />
                                  </label>

                                  <label
                                    style={wbLabelStyle}
                                  >
                                    TYPE
                                    <select
                                      value={
                                        station.type ||
                                        'other'
                                      }
                                      onChange={(event) =>
                                        updateLoadingStation(
                                          aircraft.id,
                                          loadingStations,
                                          index,
                                          'type',
                                          event.target.value
                                        )
                                      }
                                      style={wbInputStyle}
                                    >
                                      <option value="occupants">
                                        Seats
                                      </option>

                                      <option value="fuel">
                                        Fuel
                                      </option>

                                      <option value="baggage">
                                        Baggage
                                      </option>

                                      <option value="other">
                                        Other
                                      </option>
                                    </select>
                                  </label>

                                  <label
                                    style={wbLabelStyle}
                                  >
                                    ARM
                                    <input
                                      type="number"
                                      step="0.1"
                                      value={
                                        station.arm ?? ''
                                      }
                                      onChange={(event) =>
                                        updateLoadingStation(
                                          aircraft.id,
                                          loadingStations,
                                          index,
                                          'arm',
                                          event.target.value
                                        )
                                      }
                                      style={wbInputStyle}
                                    />
                                  </label>

                                  <label
                                    style={wbLabelStyle}
                                  >
                                    MAX WEIGHT
                                    <input
                                      type="number"
                                      step="0.1"
                                      value={
                                        station.maxWeight ??
                                        ''
                                      }
                                      onChange={(event) =>
                                        updateLoadingStation(
                                          aircraft.id,
                                          loadingStations,
                                          index,
                                          'maxWeight',
                                          event.target.value
                                        )
                                      }
                                      placeholder="Optional"
                                      style={wbInputStyle}
                                    />
                                  </label>

                                  {![
  'front-seats',
  'rear-seats',
  'fuel',
  'baggage',
].includes(station.id) && (
  <button
    type="button"
    onClick={() =>
      removeLoadingStation(
        aircraft.id,
        loadingStations,
        index
      )
    }
    style={removeStationButtonStyle}
  >
    REMOVE
  </button>
)}
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                      <button
                        type="button"
                        onClick={() =>
                          onSaveWbConstants(aircraft)
                        }
                        style={{
                          background: '#1ecfff',
                          color: '#090a12',
                          border: 'none',
                          borderRadius: 8,
                          padding: '0.45rem 0.9rem',
                          fontWeight: 700,
                          cursor: 'pointer',
                        }}
                      >
                        Save Weight &amp; Balance
                      </button>
                      {success && (
  <div
    style={{
      marginTop: 10,
      color: '#8ff4b6',
      fontSize: '0.82rem',
      fontWeight: 700,
    }}
  >
    {success}
  </div>
)}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
        </>
      )}
    </section>
  );
}

function getAircraftStatusMeta(status) {
  const value = String(
    status || 'serviceable'
  ).toLowerCase();

  if (value === 'aog') {
    return {
      label: 'AOG',
      icon: '🔴',
      text: '#ff8d8d',
      border: '#7f2f2f',
    };
  }

  if (value === 'deferred') {
    return {
      label: 'Deferred',
      icon: '🟠',
      text: '#ffd27a',
      border: '#7f6130',
    };
  }

  return {
    label: 'Serviceable',
    icon: '🟢',
    text: '#8ff4b6',
    border: '#2f7f4f',
  };
}

const wbLabelStyle = {
  fontSize: '0.85rem',
  color: '#d7ebff',
};

const wbInputStyle = {
  width: '100%',
  marginTop: 4,
  padding: '0.4rem',
  borderRadius: 6,
  border: '1px solid #35507f',
  background: '#1a2338',
  color: '#d7ebff',
  boxSizing: 'border-box',
};

const smallBlueButtonStyle = {
  background: '#1ecfff',
  color: '#090a12',
  border: 'none',
  borderRadius: 7,
  padding: '0.4rem 0.7rem',
  fontWeight: 700,
  cursor: 'pointer',
};

const removeStationButtonStyle = {
  background: '#3a1f2a',
  color: '#ffb1b1',
  border: '1px solid #7f3f4f',
  borderRadius: 7,
  padding: '0.45rem 0.65rem',
  fontWeight: 700,
  cursor: 'pointer',
};